import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Skeleton from '#client/components/Skeleton';
import empty from '#client/utils/empty';

import useStyles from './useStyles';

const fields = [
  {
    key: 'name',
    label: 'Name'
  },
  {
    key: 'phone',
    label: 'Phone'
  },
  {
    key: 'email',
    label: 'Email'
  },
  {
    key: 'password',
    label: 'Password'
  }
];

const formatName = (...props) => props
  .filter((val) => (!empty(val)))
  .map((val) => (val.trim()))
  .join(' ');

const AccountHolder = ({
  account: {
    firstName,
    middleName,
    lastName,
    suffix,
    accountEmail: email,
    accountPhone: phone
  } = {},
  loading,
  onClickEdit
}) => {
  const classes = useStyles();
  const account = {
    name: formatName(firstName, middleName, lastName, suffix),
    phone,
    email,
    password: !loading && '********'
  };

  return (
    <section className={classes.card}>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs>
          <Typography variant="body1" component="h2">
            Holder
          </Typography>
        </Grid>
        <Grid item xs align="right">
          <Button
            size="medium"
            variant="ghost"
            color="Wisdom"
            onClick={onClickEdit}
          >
            Edit
          </Button>
        </Grid>
      </Grid>
      <Divider className={classes.divider} aria-hidden />
      <Grid
        component="dl"
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
        className={classes.list}
      >
        {fields.map(({ key, label }) => (
          <Grid
            className={classes.listItem}
            key={key}
            component="div"
            item
            xs={12}
            sm={6}
          >
            <Typography className={classes.boldText} variant="h4" component="dt">
              {label}
            </Typography>
            <Typography className={classes.bodyText} variant="body2" component="dd" color="textSecondary" noWrap>
              {loading ? (<Skeleton width="80%" />) : account[key]}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </section>
  );
};

AccountHolder.propTypes = {
  account: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool,
  onClickEdit: PropTypes.func.isRequired
};

export default AccountHolder;
